import { useEffect, type ReactNode } from "react";

import { setApiBase } from "./client";

interface Props {
  children: ReactNode;
}

export function ApiBaseProvider({ children }: Props) {
  useEffect(() => {
    setApiBase(import.meta.env["VITE_API_BASE"] ?? "");
  }, []);
  return <>{children}</>;
}
